import { Dialog, TextField } from "@mui/material";
import { darken, lighten } from "polished";
import styled from "styled-components";

export const StyledDialog = styled(Dialog)`
  padding: 1rem 2rem;

  & .MuiPaper-root {
    width: 80%;
    max-width: 440px;
    border-radius: 5px;
  }
`;

export const StyledWebhookEventDialogHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 2rem;
  border-bottom: 1px solid ${(props) => lighten(0.9, props.theme.colors.black)};
  font-weight: 600;
  background: ${(props) => props.theme.colors.primary};

  button {
    margin-left: 0.8rem;
  }
`;

export const StyledDialogTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1rem;
  font-family: Poppins;
  font-weight: normal;
  color: ${(props) => props.theme.colors.white};
`;

export const StyledDialogContent = styled.div`
  text-align: center;
  font-size: 0.8rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

export const StyledDialogText = styled.p`
  text-align: left;
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 0.25rem;
`;

export const StyledButton = styled.button<{
  disabledStyle?: boolean;
}>`
  border: none;
  border-radius: 5px;
  padding: 0.5rem 1rem;
  width: 100%;
  font-size: 0.8rem;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.white};

  background-color: ${(props) => props.theme.colors.primary };

  background-color: ${(props) =>
    props.disabledStyle && lighten(0.1, props.theme.colors.grey)};

  font-weight: bold;
  cursor: pointer;
  flex: 1;

  &:hover {
    background-color: ${(props) => darken(0.15, props.theme.colors.primary)};

    background-color: ${(props) =>
      props.disabledStyle && lighten(0.1, props.theme.colors.grey)};
  }

  &:active {
    background-color: ${(props) => darken(0.3, props.theme.colors.primary)};

    background-color: ${(props) =>
      props.disabledStyle && lighten(0.1, props.theme.colors.grey)};
  }
`;


export const StyledInput = styled(TextField)`
  height: 2.5rem;

  .MuiOutlinedInput-root {
    height: 2.5rem;
  }

  .MuiOutlinedInput-input {
    padding: 0;
    padding-left: 14px;
    height: 2.5rem;
  }
`;